export default {
  meta: {
    title: '打靶统计',
    url: '/report/shooting' // 埋点用，记录所属模块
  },
};
